import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-xxl flex-grow-1 container-p-y"
}
const _hoisted_2 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Add"),
    /*#__PURE__*/_createTextVNode("Category ")
  ])
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 col-sm-12" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-fullname"
}, "Category Title", -1)
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "input-group input-group-merge" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  id: "basic-icon-default-fullname2",
  class: "input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-buildings" })
], -1)
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "Ulr/Slug ", -1)
const _hoisted_16 = { class: "col-sm-12" }
const _hoisted_17 = { class: "input-group input-group-merge" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  id: "basic-icon-default-company2",
  class: "input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-buildings" })
], -1)
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "SEO", -1)
const _hoisted_21 = { class: "col-sm-12" }
const _hoisted_22 = { class: "input-group input-group-merge" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  id: "basic-icon-default-company2",
  class: "input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-buildings" })
], -1)
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 form-label",
  for: "basic-icon-default-phone"
}, "Meta Description", -1)
const _hoisted_26 = { class: "col-sm-12" }
const _hoisted_27 = { class: "input-group input-group-merge" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  id: "basic-icon-default-company2",
  class: "input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-buildings" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-3\"><label class=\"col-sm-12 col-form-label\" for=\"basic-icon-default-email\">Meta Schema</label><div class=\"col-sm-12\"><div class=\"input-group input-group-merge\"><span class=\"input-group-text\"><i class=\"bx bx-envelope\"></i></span><input type=\"text\" id=\"basic-icon-default-email\" class=\"form-control\" placeholder=\"Enter Schema !\"></div></div></div>", 1)
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4 col-sm-12\"><div class=\"card\"><div class=\"card-body\"><div class=\"page-image\"><img src=\"https://www.imageeditexpert.com/uploads/images/about/about.png\" alt=\"n/a\" class=\"slider-setting-img\"></div><div class=\"mb-3\"><label for=\"formFile\" class=\"form-label\">Image Choose</label><input class=\"form-control\" type=\"file\" id=\"formFile\"></div><div class=\"row justify-content-end\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary\">Send</button></div></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CkEditor = _resolveComponent("CkEditor")!

  return (_ctx.isDataTrue == false)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, "hello this is category " + _toDisplayString(_ctx.isDataTrue), 1),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-primary mt-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateIsDataTrue && _ctx.updateIsDataTrue(...args)))
            }, " Category List ")
          ])
        ]),
        _createElementVNode("form", {
          name: "",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "basic-icon-default-fullname",
                            placeholder: "Page title",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.title) = $event)),
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.formData.title]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "basic-icon-default-company",
                            class: "form-control",
                            placeholder: "Page alias.",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.alias) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formData.alias]
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_CkEditor),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "basic-icon-default-company",
                            class: "form-control",
                            placeholder: "Site Slogan/Description !",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.description) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formData.description]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "basic-icon-default-phone",
                            class: "form-control phone-mask",
                            placeholder: "Site Slogan/Description !",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.meta) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formData.meta]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_29
                  ])
                ])
              ])
            ]),
            _hoisted_30
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}